interface Props {
  stepNumber: number
  totalSteps: number
}

export function WizardStepPill({ stepNumber, totalSteps }: Props) {
  return (
    <span className="mb-2 inline-flex w-fit items-center rounded-full bg-brand/10 px-2 py-0.5 text-xs font-medium text-brand">
      Step {stepNumber} of {totalSteps}
    </span>
  )
}
